// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3zgFY","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1SZSA"};